import { type FC, type ReactNode } from "react";
import { Button } from "~/common/mui";

export const CloseBtn: FC<{
  children?: ReactNode;
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
}> = (props) => {
  return <Button variant={"text"} data-test-id={"add-to-cart-btn-cancel"} {...props} />;
};
